import 'css-chunksrc/client/pages/zonePage/projectsPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_1odoe_1",
  "text": "_text_1odoe_17",
  "icon": "_icon_1odoe_21"
};